import React from "react";
import InvitationTable from "../../components/Invitations/InvitationTable";
import { getPlan, getToken } from "../../lib";
import { Paper } from "material-ui";

class Invitations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rooms: [],
      hasFetchedRooms: false,
    };
  }

  componentDidMount() {
    if (this.props.location && this.props.location.state) {
      this.fetchRooms();
      const token = getToken();
      this.props.fetchInvitations(token, this.props.location.state.isWebinar);
      if (!this.props.hasFecthedEmailAddressBook) {
        this.props.fetchAddressBook(token);
      }
      if (!this.props.hasFetchedGroups) {
        this.props.fetchGroups(token);
      }
    } else {
      this.props.history.goBack();
    }

    // if(this.props)
  }

  fetchRooms = async () => {
    const isWebinar = this.props.location.state.isWebinar;
    const res = await getPlan(isWebinar ? 1 : 0);
    if (res.data.hasOwnProperty("rooms")) {
      this.setState({
        rooms: res.data.rooms,
        hasFetchedRooms: true,
      });
    } else {
      console.log("Error while fetching the room: ");
      this.setState({ hasFetchedRooms: true });
    }
  };

  render() {
    return (
      <Paper style={{ borderRight: "2px solid #e3e3e3", padding: "16px" }}>
        <InvitationTable
          fetchEmailAddressBook={this.props.fetchAddressBook}
          rooms={this.state.rooms}
          hasFetchedRooms={this.state.hasFetchedRooms}
          {...this.props}
        />
      </Paper>
    );
  }
}

export default Invitations;



// WEBPACK FOOTER //
// src/routes/Invitations/Invitations.js